import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { classnames } from 'helpers/utils';
import { ChevronIcon } from 'assets/icons';
import { RouteName, goToPage } from 'routes';
import styles from './contributor-table-row-mobile.module.scss';

type ContributorRowMobileProps = {
  vaults: VaultType[];
};

const ContributorRowMobile: React.FC<ContributorRowMobileProps> = ({
  vaults,
}) => (
  <div className={styles.vaultsCardsMobile}>
    <div
      className={classnames(
        styles.body,
        'text__body__regular__medium__gray700',
      )}
    >
      {vaults.map((vault: VaultType) => (
        <div key={vault.id} className={styles.vaultCard}>
          <div className={styles.leftSize}>
            <div
              className={classnames(
                'text__body__semi__bold__medium__gray800',
                styles.vaultName,
              )}
            >
              {vault.title}
            </div>
            <div className={classnames(styles.owner)}>
              <span
                className={classnames('text__body__semi__bold__small__gray700')}
              >
                {' '}
                Owner:{' '}
              </span>
              <span
                className={classnames('text__body__regular__small__gray700')}
              >
                {vault.owner.name}
              </span>
            </div>
            <div className={classnames(styles.company)}>
              <span
                className={classnames('text__body__semi__bold__small__gray700')}
              >
                {' '}
                Company:{' '}
              </span>
              <span
                className={classnames('text__body__regular__small__gray700')}
              >
                {vault.owner.companyName ? vault.owner.companyName : '-'}
              </span>
            </div>
          </div>
          <div className={styles.rightSize}>
            <Button
              className={styles.detailsButton}
              buttonStyle={ButtonStyle.PrimaryGhost}
              buttonSize={ButtonSize.Small}
              onClick={() => {
                goToPage(RouteName.VaultDetail, { id: vault.id });
              }}
            >
              <ChevronIcon className={styles.chevronIcon} />
            </Button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export { ContributorRowMobile };
